import React from "react";

function Popup({ message, onClose }) {
  return (
    <div className="popup">
      <div className="popup-content bg-red-500 text-white p-4 rounded-lg">
        <p>{message}</p>
        <button className="close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default Popup;
